module.exports = __webpack_public_path__ + "media/images/home-promo-2-7140286b6c82142bf20b63b1ee54f305.jpg";